<template>
  <div class="flex h-6 w-48 md:w-80 lg:w-full items-center pl-2">
    <keep-alive>
      <component class="w-8" :is="cardBrandLogo" />
    </keep-alive>
    <span v-if="card" class="w-full flex justify-center"> xxxx xxxx xxxx {{card.card_last_four}}</span>
  </div>
</template>

<script>
import mastercardLogo from './MastercardLogo.vue';
import amexLogo from './AmexLogo.vue';
import visaLogo from './VisaLogo.vue';

export default {
  props: ['card'],

  data() {
    return {
      cardBrandLogo: null,
    };
  },

  mounted() {
    this.cardBrandLogo = `${this.card.card_brand}Logo`;
  },

  components: {
    mastercardLogo,
    amexLogo,
    visaLogo,
  },
};
</script>
